import "./App.css";
import Home from './Screen/Home';
import About from './Screen/About';
import WashingMachine from './Screen/WashingMachine';
import FridgeService from './Screen/FridgeService';
import AcService from './Screen/AcService';
import Contact from './Screen/Contact';
import PrivacyPolicy from "./Screen/privacypolicy";
import TermsConditions from './Screen/TermsConditions';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <>    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/WashingMachine" element={<WashingMachine />} />
          <Route path="/FridgeService" element={<FridgeService />} />
          <Route path="/AcService" element={<AcService />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>

    <section>
    <a href="tel:+919176849803" class="fixed-call-button">
        <i class="fas fa-phone-alt phone-icon"></i>
    </a>
</section>  


</>


  );
}

export default App;
